var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app-bar",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize",
        },
      ],
      attrs: {
        "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
        app: "",
        color: "bar",
        dense: "",
      },
    },
    [
      _c(
        "v-toolbar-title",
        { staticClass: "pr-2", attrs: { id: "toolbar_title" } },
        [
          _vm.showBackButton
            ? _c(
                "v-app-bar-nav-icon",
                {
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.goBack.apply(null, arguments)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-arrow-left")])],
                1
              )
            : _vm._e(),
          !_vm.minimalTopbar
            ? _c(
                "v-app-bar-nav-icon",
                {
                  attrs: { "data-cy": "openSidebar" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$emit("toggle-drawer")
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { color: "bar-visible" } }, [
                    _vm._v("mdi-menu"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c("span", { staticClass: "hidden-sm-and-down bar-visible--text" }, [
            _vm._v(_vm._s(_vm.elipsisTitle)),
          ]),
        ],
        1
      ),
      _c("v-spacer"),
      _vm._t("content"),
      _c("TopbarDropdown"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }